import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface ICustomerList {
    [key: string]: any;
    loading: boolean;
    infos: Array<{ [key: string]: any }>;
}

export interface IState {
    noticeList: ICustomerList;
    typeNoticeList: ICustomerList;
    noticeDetail: {[key: string]: any};
    addNoticeCommentRes: {[key: string]: any};
    delNoticeCommentRes: {[key: string]: any};
    isNoticePermission: boolean;
}

export const state: IState = {
    noticeList: {                                                    // 公告分页数据
        loading: false,
        infos: []
    } as ICustomerList,
    typeNoticeList: {                                                // 公告分类分页数据
        loading: false,
        infos: []
    } as ICustomerList,
    noticeDetail: { loading: false, info: {} },                      // 公告详情
    addNoticeCommentRes: { loading: false, success: false},          // 公告新增评论
    delNoticeCommentRes: { loading: false, success: false},                // 公告删除评论
    isNoticePermission: false
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
    typeNoticeList: (myState: IState) => myState.typeNoticeList,
    noticeList: (myState: IState) => myState.noticeList,
    noticeDetail: (myState: IState) => myState.noticeDetail,
    addNoticeCommentRes: (myState: IState) => myState.addNoticeCommentRes,
    delNoticeCommentRes: (myState: IState) => myState.delNoticeCommentRes,
    isNoticePermission: (myState: IState) => myState.isNoticePermission
};
